'use client';

import { useLocale } from 'next-intl';
import { useMemo } from 'react';

import { useIndustryChildrenQuery, useIndustryRootsQuery } from '@/modules/shared/application';
import { toListCollectionFromLeafs } from '@/utils';

export const useIndustryCollections = (industryId?: string) => {
	const locale = useLocale();

	const { data: industries = [] } = useIndustryRootsQuery();
	const { data: subIndustries = [] } = useIndustryChildrenQuery(industryId);

	const industryCollection = useMemo(
		() => toListCollectionFromLeafs(industries, locale),
		[ industries, locale ],
	);
	const subIndustryCollection = useMemo(
		() => toListCollectionFromLeafs(subIndustries, locale),
		[ subIndustries, locale ],
	);

	return {
		industryCollection,
		subIndustryCollection,
	};
};
